import LazyImage from "@/components/LazyImage";

export interface SharedAmenitiesProps {
  title: string;
  description: string;
  facility: { id: string; icon: string; is_new: boolean; label: string }[];
}

export default function SharedAmenities(props: SharedAmenitiesProps) {
  const facilitiesSafe = (props.facility ?? []).filter((f) => f && typeof f.icon === "string" && f.icon);
  const newFacilities = facilitiesSafe.filter((f) => f.is_new);
  const facilities = facilitiesSafe.filter((f) => !f.is_new);

  return (
    <div>
      <h1
        className="text-white xl:text-5xl text-center font-pluto"
        dangerouslySetInnerHTML={{ __html: props.title }}
      ></h1>
      <h2
        className="mt-3.5 mx-6 xl:mx-0 xl:mt-14 text-[13px] xl:text-3xl text-white xl:leading-12 text-center"
        dangerouslySetInnerHTML={{ __html: props.description }}
      ></h2>

      <div className="hidden xl:flex flex-col w-full mt-10 xl:mt-20 gap-y-7 xl:gap-y-14 gap-x-2.5 xl:gap-x-12 xl:px-10">
        <div className="grid grid-flow-col auto-cols-fr">
          {newFacilities.map((facility, index) => {
            return (
              <div key={index} className="flex flex-col items-center">
                <div className="relative">
                  <LazyImage
                    src={facility.icon}
                    loading="lazy"
                    alt="spa"
                    width={100}
                    height={100}
                    className="w-[3rem] xl:w-16 h-[3rem] xl:h-16"
                    rootMargin="50px 0px 0px 0px"
                  />

                  {facility.is_new && (
                    <LazyImage
                      src="/homepage/New.png"
                      alt="new"
                      loading="lazy"
                      width={42}
                      height={42}
                      className="absolute -top-5 -right-3 xl:-right-10 w-[1.1rem] xl:w-[2.5rem] h-[1.1rem] xl:h-[2.5rem]"
                    rootMargin="50px 0px 0px 0px"

                    />
                  )}
                </div>

                <p className="text-white text-[7px] xl:text-2xl text-center font-pluto mt-4 whitespace-normal !font-normal">
                  {facility.label}
                </p>
              </div>
            );
          })}
        </div>

        <div className="grid grid-flow-col auto-cols-fr">
          {facilities.map((facility, index) => {
            return (
              <div key={index} className="flex flex-col items-center">
                <div className="relative">
                  <LazyImage
                    src={facility.icon}
                    loading="lazy"
                    alt="spa"
                    width={64}
                    height={64}
                    className="w-[3rem] xl:w-16 h-[3rem] xl:h-16"
                    rootMargin="50px 0px 0px 0px"

                  />

                  {facility.is_new && (
                    <LazyImage
                      src="/homepage/New.png"
                      alt="new"
                      loading="lazy"
                      width={42}
                      height={42}
                      className="absolute -top-5 -right-3 xl:-right-10 w-[1.1rem] xl:w-[2.5rem] h-[1.1rem] xl:h-[2.5rem]"
                    rootMargin="50px 0px 0px 0px"
                    />
                  )}
                </div>

                <p className="text-white text-[7px] xl:text-2xl text-center font-pluto mt-4 whitespace-normal !font-normal">
                  {facility.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="grid xl:hidden grid-cols-4 xl:grid-cols-5 w-full mt-10 xl:mt-20 gap-y-7 xl:gap-y-14 gap-x-2.5 xl:gap-x-12 xl:px-10">
        {facilitiesSafe.map((facility, index) => {
          return (
            <div key={index} className="flex flex-col items-center">
              <div className="relative">
                <LazyImage
                  src={facility.icon}
                  loading="lazy"
                  alt="spa"
                  width={100}
                  height={100}
                  className="w-[3rem] xl:w-16 h-[3rem] xl:h-16"
                  rootMargin="50px 0px 0px 0px"
                />

                {facility.is_new && (
                  <LazyImage
                    src="/homepage/New.png"
                    alt="new"
                    loading="lazy"
                    width={42}
                    height={42}
                    className="absolute -top-5 -right-3 xl:-right-10 w-[1.1rem] xl:w-[2.5rem] h-[1.1rem] xl:h-[2.5rem]"
                    rootMargin="50px 0px 0px 0px"
                  />
                )}
              </div>

              <p className="text-white text-[7px] xl:text-2xl text-center font-pluto mt-4 whitespace-normal">
                {facility.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
